module.exports = __webpack_public_path__ + "static/media/SR920.b9b42909.png";